export const arrayGetLast = <T>(array: Array<T>) => {
  if (!array || array.length === 0) return null;

  return array[array.length - 1];
};

export const getEnumArray = <T extends string>(type: any) => Object.keys(type).map((x) => x as T);

export const arraySum = (array: Array<number>) => {
  if (!array || array.length === 0) return 0;

  return array.reduce((a, b) => a + b, 0);
};

export const compareArray = <T>(a: Array<T>, b: Array<T>) => JSON.stringify(a) !== JSON.stringify(b);
